import { useState } from "react";
import { apiClient } from "@/api/base44Client";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function SecuritySettings({ user }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const hasPassword = !!user?.has_password;

  const submit = async (e) => {
    e.preventDefault();
    if (!next) { toast.error("Skriv inn et nytt passord"); return; }
    if (next !== confirm) { toast.error("Passordene er ikke like"); return; }
    setSaving(true);
    try {
      await apiClient.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Passord oppdatert");
      setCurrent(""); setNext(""); setConfirm("");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Kunne ikke oppdatere passord");
    } finally { setSaving(false); }
  };

  return (
    <Card className="p-6 max-w-lg" data-testid="security-settings">
      <div className="flex items-center gap-3 mb-5">
        <div className="w-10 h-10 rounded-xl bg-brand-ink text-brand-lime flex items-center justify-center"><KeyRound className="w-5 h-5" /></div>
        <div>
          <h3 className="font-semibold text-brand-ink">{hasPassword ? "Endre passord" : "Opprett passord"}</h3>
          <p className="text-sm text-slate-500">
            {hasPassword
              ? "Oppdater passordet du bruker for innlogging med e-post."
              : "Sett et passord så du kan logge inn med e-post i tillegg til Google."}
          </p>
        </div>
      </div>
      <form onSubmit={submit} className="space-y-4">
        {hasPassword && (
          <div>
            <Label htmlFor="cur-pw">Nåværende passord</Label>
            <Input id="cur-pw" type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} className="mt-1.5" data-testid="current-password-input" />
          </div>
        )}
        <div>
          <Label htmlFor="new-pw">Nytt passord</Label>
          <Input id="new-pw" type="password" autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} className="mt-1.5" data-testid="new-password-input" />
        </div>
        <div>
          <Label htmlFor="conf-pw">Bekreft nytt passord</Label>
          <Input id="conf-pw" type="password" autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5" data-testid="confirm-password-input" />
        </div>
        <Button type="submit" disabled={saving} data-testid="save-password-button">
          {saving ? "Lagrer..." : hasPassword ? "Oppdater passord" : "Opprett passord"}
        </Button>
      </form>
    </Card>
  );
}
